import React from 'react'
import {SlackIcon} from '../../icon/slack-icon/SlackIcon'

export const ContactBody = (props: {
    email: string | undefined,
    slackUserId: string | undefined,
    companyId: number | undefined
}): JSX.Element => {
	let mailContent

	if (props?.email) {
		mailContent = <a title={props.email} target={'_blank'} href={'mailto:' + props.email} rel="noreferrer"><i
			className={'fas fa-envelope mr-2 business-card-social'}/></a>
	}

	return (<>
		{mailContent}
		<SlackIcon slackUserId={props?.slackUserId} companyId={props?.companyId}/>
	</>)
}